import React, { useEffect, useRef, useState } from "react";
import { IconButton, TextField } from "@material-ui/core";
import Button from "components/CustomButtons/Button.jsx";

const HighlightsListInput = ({ label, value, onChange, readOnly }) => {
    const raw = value || "";
    const items = raw.length ? raw.split("\n") : [""];
    const inputsRef = useRef([]);
    const [focusIndex, setFocusIndex] = useState(null);

    useEffect(() => {
        if (focusIndex !== null && inputsRef.current[focusIndex]) {
            inputsRef.current[focusIndex].focus();
            setFocusIndex(null);
        }
    }, [focusIndex, items.length]);

    const commit = (newItems) => {
        onChange(newItems.join("\n"));
    };

    const updateAt = (i, val) => {
        const next = items.slice();
        next[i] = val;
        commit(next);
    };

    const insertAfter = (i) => {
        const next = items.slice();
        next.splice(i + 1, 0, "");
        commit(next);
        setFocusIndex(i + 1);
    };

    const removeAt = (i) => {
        const next = items.slice();
        next.splice(i, 1);
        if (next.length === 0) next.push("");
        commit(next);
    };

    return (
        <div>
            {label && <h4 style={{ marginBottom: 8 }}>{label}</h4>}
            {items.map((item, i) => (
                <div key={i} style={{ display: "flex", alignItems: "center", marginBottom: 4 }}>
                    <span style={{ marginRight: 8 }}>•</span>
                    <TextField
                        inputRef={(el) => { inputsRef.current[i] = el; }}
                        value={item}
                        fullWidth
                        InputProps={{ readOnly: readOnly ? true : false }}
                        onChange={(e) => updateAt(i, e.target.value)}
                        onKeyDown={(e) => {
                            if (readOnly) return;
                            if (e.key === "Enter") {
                                e.preventDefault();
                                insertAfter(i);
                            }
                        }}
                    />
                    {!readOnly && <IconButton onClick={() => removeAt(i)}>
                        <i className="red-text fa fa-trash" />
                    </IconButton>}
                </div>
            ))}
            {!readOnly && <Button color="primary" size="sm" onClick={() => insertAfter(items.length - 1)}>
                <i className="fa fa-plus" /> Add Item
            </Button>}
        </div>
    );
};

export default HighlightsListInput;
